import React from 'react'

import AddressField from '../AddressField/AddressField'


const ReadableAddressField = ({ valueLink }) => valueLink.value && (
  <AddressField>
    {valueLink.value}
  </AddressField>
)

export default ReadableAddressField
